import { type FC } from 'react';
import { Stack } from '@mantine/core';
import { type PayoutTicket } from '~/entities/payout';
import { PayoutTicketStatus } from '~/entities/payout';
import { ResolveTicket } from '../actions';
import { TicketDetails } from '../components/TicketDetails';

interface ManageTicketProps {
    ticket: PayoutTicket;
    onReslove?: () => void;
    onError?: () => void;
}

export const ManageTicket: FC<ManageTicketProps> = ({ ticket, onReslove, onError }) => {
    const resolveEnabled = ticket.status === PayoutTicketStatus.STATUS_CREATED;

    return (
        <Stack>
            <TicketDetails ticket={ticket} />

            {resolveEnabled && (
                <ResolveTicket
                    id={ticket.id?.value}
                    onSuccess={onReslove}
                    onError={onError}
                />
            )}
        </Stack>
    );
};
